import React, { useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import AppActions from '../../actions/app';
import TranslationUtil from '../../utils/TranslationUtil';
import { capitalizeBrand } from '../../utils/BrandUtil';
import { getEgLinks } from './eglinks';
import BottomLinks from './BottomLinks';
import EgLogo from '../EgLogo';

export function EgFooter() {
    const getPropsFromState = (state) => {
        const {
            brand, locale, getFooterLinks, features
        } = state.app;
        const { app } = state;
        const { showComplianceNotice } = features;
        const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
        const getTranslation = (suffix) => translations.getTranslation(`footer.${suffix}`);

        /* istanbul ignore next */
        const mapTranslation = (column) => column.map((linkElement) => ({
            linkText: getTranslation(`links.${linkElement.key}`),
            link: linkElement.value
        }));

        const brandLinks = getEgLinks(locale.canonical);
        Object.keys(brandLinks).forEach(
            (column) => {
                brandLinks[column] = mapTranslation(brandLinks[column]);
            }
        );

        const brandName = capitalizeBrand(brand);
        const getVrboTranslation = (suffix, params) => translations.getTranslation(`Vrbo.footer.${suffix}`, params);
        const compNotice = getVrboTranslation('complianceNotice', { brandName });
        const earningsEst = getVrboTranslation('earningsEst');
        const airbnbData = getVrboTranslation('airbnb');
        const showAirBnbData = locale.display === 'en-us';

        return {
            links: brandLinks,
            helpMessage: getTranslation('helpMessage'),
            brand,
            locale: locale.canonical,
            getFooterLinks,
            compNotice,
            earningsEst,
            airbnbData,
            showAirBnbData,
            showComplianceNotice
        };
    };

    const {
        brand,
        locale,
        getFooterLinks,
        links,
        helpMessage,
        compNotice,
        earningsEst,
        airbnbData,
        showAirBnbData,
        showComplianceNotice
    } = useSelector(getPropsFromState, shallowEqual);

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(AppActions.getFooterLinks(brand, locale));
    }, []);

    if (typeof window !== 'object') return null;

    return (
        <div className="eg-footer">
            <div className="eg-footer__container">
                <div className="eg-footer__wrapper">
                    <footer>
                        <section className="eg-footer__main">
                            <div className="eg-footer__main-item">
                                <ul>
                                    {links.column1.map((element) => (
                                        <li>
                                            <a
                                                href={element.link}
                                                key={element.linkText}
                                            >
                                                {element.linkText}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="eg-footer__main-item">
                                <ul>
                                    {links.column2.map((element) => (
                                        <li>
                                            <a
                                                href={element.link}
                                                key={element.linkText}
                                            >
                                                {element.linkText}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="eg-footer__main-item">
                                <EgLogo callStatus={getFooterLinks} isFooter />
                                <p className="eg-footer__help-message">{`${helpMessage}`}</p>
                            </div>
                        </section>

                        <section className="eg-footer__main eg-footer__legal">
                            <BottomLinks />
                        </section>

                        {showComplianceNotice && (
                            <section>
                                <div className="eg-footer__compliance">
                                    <p>
                                        {`${compNotice}`}
                                    </p>
                                    <p>
                                        {`${earningsEst}`}
                                    </p>
                                    {showAirBnbData && (
                                        <p>
                                            {`${airbnbData}`}
                                        </p>
                                    )}
                                </div>
                            </section>
                        )}

                    </footer>
                </div>
            </div>
        </div>
    );
}

EgFooter.displayName = 'EgFooter';
export default EgFooter;
